import styles from './academyCodes.module.scss';
import {fieldRules} from 'utils/helper';
import {DatePicker, Form, Input, Select, Switch} from 'antd';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {useLazyQuery} from '@apollo/client';
import {GET_ALL_ACADEMY_CODES} from './resolvers';
import moment from 'moment';
import {toast} from 'react-toastify';

export const ExportAcademyCodes = ({close}) => {
  const [form] = Form.useForm();
  const [exportData, {loading}] = useLazyQuery(GET_ALL_ACADEMY_CODES, {
    variables: {
      filter: {
        page: 1,
        limit: 10,
      },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
    onError: error => toast.error(error.message),
  });
  return (
    <div className={styles.container}>
      <h2>Export File</h2>
      <Form
        form={form}
        onFinish={values => {
          const {startDate, emails, endDate, ...rest} = values;
          exportData({
            variables: {
              filter: {
                ...rest,
                emails: [emails],
                startDate: startDate ? moment(startDate).format() : null,
                endDate: endDate ? moment(endDate).format() : null,
                export: true,
              },
            },
          }).then(({data: {getAllCoupons}}) => {
            if (
              getAllCoupons?.statusCode === 400 ||
              getAllCoupons?.__typename === 'Error'
            ) {
              toast.error(getAllCoupons?.message);
              return;
            } else {
              toast.success(getAllCoupons?.message);
              close();
              form.resetFields();
            }
          });
        }}
        layout="vertical">
        <Form.Item
          rules={[
            fieldRules('This'),
            {type: 'email', message: 'Please input a valid email'},
          ]}
          name="emails"
          label="Email">
          <Input type="email" placeholder="admin@joindaba.com" />
        </Form.Item>
        <Form.Item
          name="promoCodeType"
          className={styles.field}
          label="Promo Code Type">
          <Select allowClear>
            <Select.Option value="LIMITED">Limited</Select.Option>
            <Select.Option value="UNLIMITED">Unlimited</Select.Option>
          </Select>
        </Form.Item>
        <div className={styles.fixedDiscount}>
          <Form.Item
            className={styles.field}
            label="Start Date"
            name="startDate">
            <DatePicker placeholder="Start Date" showTime allowClear />
          </Form.Item>
          <Form.Item className={styles.field} label="End Date" name="endDate">
            <DatePicker placeholder="End Date" showTime allowClear />
          </Form.Item>
        </div>
        <Form.Item name="isEnabled" label="Enabled Promo Codes">
          <Switch />
        </Form.Item>
        <SubmitButton disabled={loading} label="Download" />
      </Form>
    </div>
  );
};
